import React from "react";
import { withRouter } from "react-router-dom";
import Text from "../../components/typography/Text";
import Button from "../../components/buttons/Button";
import Dialog from "../../components/dialogs/Dialog";
import fetchApi from "../../fetchApi";

export default withRouter(
  ({ loggedUser, onClick, history, refresh, ...work }) => {
    const [showDialog, toggleDialog] = React.useReducer((s) => !s, false);
    const imageUrl =
      work.image && work.image.breakpoints
        ? work.image.base_path + work.image.breakpoints.xs["1x"]
        : "";

    const click = (event) => {
      const isButton =
        event.target.className && typeof event.target.className === "string"
          ? event.target.className?.includes("button")
          : false;
      if (!isButton) onClick();
    };

    const deleteWork = async () => {
      try {
        const result = await fetchApi(`/work/${work.id}`, {
          method: "delete",
        });
        console.log({ result });
        if (result && result.status === "trash") {
          toggleDialog();
          refresh();
        } else {
          alert("Can't delete project. Please contact an administrator.");
          throw new Error(result);
        }
      } catch (error) {
        console.error(error);
      }
    };

    return (
      <>
        <div className="oDesignerProject" onClick={click}>
          <div
            className="oDesignerProject_image"
            style={{
              backgroundImage: `url(${imageUrl})`,
            }}
          >
            {loggedUser && (
              <div className="oDesignerProject_buttons">
                <Button
                  icon="pencil"
                  iconSize="16px"
                  black
                  rounded
                  onClick={() => history.push("/designer/editwork", { work })}
                >
                  Edit
                </Button>
                <Button icon="close" black rounded onClick={toggleDialog}>
                  Delete
                </Button>
              </div>
            )}
          </div>
          <h5>{work.title.rendered}</h5>
          <Text small>{work.client}</Text>
        </div>
        <Dialog show={showDialog} toggle={toggleDialog}>
          <div className="dialog_content">
            <h4>Delete project</h4>
            <Text small>
              Are you sure you want to delete "{work.title.rendered}" ?
            </Text>
            <div className="dialog_actions">
              <Button outlined rounded onClick={toggleDialog}>
                Cancel
              </Button>
              <Button rounded onClick={deleteWork}>
                Delete
              </Button>
            </div>
          </div>
        </Dialog>
      </>
    );
  }
);
